import { useContext } from 'react';
import { sleep } from '../../../../../helpers/common';
import { propChildren, propShape, } from '../../../../../helpers/custom-prop-types';
import { useDidMount } from '../../../../../helpers/use/useHook';
import { Select2MultipleInputOnlyContainerFieldContext } from './Select2MultipleInputOnlyContainerField';
const Select2MultipleInputOnlyLabel = (props) => {
    const { children, innerProps, selectProps } = props;
    const { render } = selectProps;
    const { input, meta } = useContext(Select2MultipleInputOnlyContainerFieldContext);
    useDidMount(() => {
        sleep(0).then(() => {
            input.onBlur(input.value);
        });
    });
    return render({
        children,
        innerProps,
        input,
        meta,
    });
};
Select2MultipleInputOnlyLabel.propTypes = {
    children: propChildren().isRequired,
    innerProps: propShape().isRequired,
    selectProps: propShape().isRequired,
};
export default Select2MultipleInputOnlyLabel;
